// SR-CUSTOM: Door Visualiser on the Ensemble product pages (David, 19 Oct 2026). Loaded by snippets/block--product-buy-buttons.liquid
// on /products/<material>-ensemble-handle only, after assets/dyo-door.js, whose rendering engine it uses (window.SRDoorEngine).
// It appears only once a size and a finish are both chosen (before that the big photo is the group shot).
// Phones (under 768px): a "Door Visualiser" bar beside "Gallery" under the photo; the colour panel opens under the two bars.
// Desktop (768px and up, option E on the design canvas): a dark pill on the photo, bottom-left, with three colour dots and
// "Try it on your door" (+ a "New" tag until it has been used). The first time it appears in a visit, the dots fan out through
// a few door colours and the pill pulses once. Hovering shows a "See it on your door" how-to card that pops out of the pill
// (only until it has been used once; then hover goes straight to the colours). "Show me" or clicking the pill opens the colour
// panel in the same place. Touch screens: the first tap shows the card, later taps open the colours.
// Picking a door redraws the big product photo on that door when it is a size-and-finish photo with visualiser layers
// (vis-manifest.json); the hero, room and gallery photos stay as they are. The theme rebuilds the big photo whenever the size or
// finish changes, so the drawing (and the pill) are put back each time. The choice is shared with Design Your Own
// (localStorage "sr-door"); "sr-door-tip" remembers the card has been seen. The shortlist heart saves the door with the design
// (window.SRDoorPick, read by assets/sr-shortlist.js).
// Before both are chosen (all widths, design canvas row 5 "1"): a "Choose a size and finish" prompt sits in the pill's place, with
// step circles that tick as each is picked; a click points to what's missing (window.SRChoose in assets/sr-variant-guard.js).
// Tracking: dyo_door_open, dyo_door and dyo_door_tip, as on Design Your Own, with page "product". Styles: assets/sr-door-pdp.css.
(function () {
  var E = window.SRDoorEngine, cfgEl = document.querySelector('[data-sr-door-pdp]');
  if (!E || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  E.init(cfg.manifest);
  var media = document.querySelector('.media-area[id^="big-image-"]');
  var mnav = document.querySelector('nav.product-action-buttons.--mobile');
  if (!media) return;

  var OPTIONS = E.options();   // laminate and timber doors, with close-match colours flagged (assets/dyo-door.js)

  var door = null, tab = 'laminate', isOpen = false, seen = false, pinned = false, leaveT;
  try { var sv = JSON.parse(localStorage.getItem('sr-door') || 'null'); if (sv && OPTIONS[sv]) door = OPTIONS[sv]; } catch (e) {}
  try { seen = localStorage.getItem('sr-door-tip') === '1'; } catch (e) {}
  if (door) { tab = door.kind; seen = true; }      // already used the visualiser (here or on Design Your Own)
  var doorWords = E.doorWords;
  function M() { return E.data(); }
  function texture(o, w) { var m = M(); return o.kind === 'timber' && m && m.textures.panels[o.id] ? E.swatchUrl(o.id, w) : ''; }   // grain-scale crop
  function desk() { return !mnav || window.matchMedia('(min-width: 768px)').matches; }
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // The chosen size and finish (both must be picked before the big photo is a size-and-finish photo)
  function picked() {
    var p = {};
    document.querySelectorAll('variant-selects input:checked').forEach(function (i) { p[i.name] = i.value; });
    return p;
  }
  function track(name, extra) {
    var p = picked(), q = { page: 'product', product: cfg.handle, size: p['Size'] || '', button: p['Detail Finish'] || '' };
    Object.keys(extra || {}).forEach(function (k) { q[k] = extra[k]; });
    var meta = { door_open: 'DYODoorOpen', door: 'DYODoor', door_tip: 'DYODoorTip' };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dyo_' + name, q); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'dyo_' + name, q); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', meta[name], q); } catch (e) {}
  }

  var CHEV = '<svg class="sr-door-chev" viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="M1.5 3.5L5 7l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';

  // ---- phones: the bar beside Gallery
  var mbtn = null;
  if (mnav) {
    mbtn = document.createElement('button');
    mbtn.type = 'button';
    mbtn.className = 'text-button size--small subheading flex pt-8 pb-8 sr-door-btn';
    mbtn.setAttribute('aria-expanded', 'false');
    mbtn.setAttribute('aria-controls', 'sr-door-pop');
    mbtn.innerHTML = '<i class="sr-door-dot" aria-hidden="true"></i><span class="sr-door-label">Door Visualiser</span>' + CHEV;
    mnav.appendChild(mbtn);
  }

  // ---- desktop: the pill on the photo with its how-to card
  var fl = document.createElement('div');
  fl.className = 'sr-door-float';
  fl.hidden = true;
  fl.innerHTML = '<div class="sr-door-card" role="dialog" aria-label="See it on your door" hidden>' +
    '<div class="sr-door-card-top"><span class="sr-door-new">New</span><button type="button" class="sr-door-x" data-card-close aria-label="Close">×</button></div>' +
    '<p class="sr-door-card-title">See it on your door</p>' +
    '<ol class="sr-door-steps"><li>Pick a laminate or timber door.</li><li>The photo updates to show this handle on it.</li><li>Save your favourite with the ♡ beside Add to cart.</li></ol>' +
    '<div class="sr-door-card-btns"><button type="button" class="sr-door-show" data-card-show>Show me</button><button type="button" class="sr-door-got" data-card-close>Got it</button></div></div>' +
    '<button type="button" class="sr-door-pill" aria-expanded="false" aria-controls="sr-door-pop"><span class="sr-door-dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
    '<span class="sr-door-pill-label">Try it on your door</span><span class="sr-door-new" data-new>New</span>' + CHEV + '</button>';
  var card = fl.querySelector('.sr-door-card'), pill = fl.querySelector('.sr-door-pill');
  function activeBtn() { return desk() ? pill : mbtn; }

  // ---- until a size and finish are chosen: the prompt on the photo (arrow → on desktop, ↓ on phones, set in the CSS)
  var ch = document.createElement('button');
  ch.type = 'button';
  ch.className = 'sr-choose';
  ch.hidden = true;
  ch.innerHTML = '<span class="sr-choose-steps" aria-hidden="true"><i>1</i><i>2</i></span><span class="sr-choose-text"></span><span class="sr-choose-arrow" aria-hidden="true"></span>';
  var chText = ch.querySelector('.sr-choose-text'), chSteps = ch.querySelectorAll('.sr-choose-steps i');
  ch.addEventListener('click', function (e) { e.stopPropagation(); if (window.SRChoose) window.SRChoose.point(); });
  // Both live in one layer over the photo; the CSS keeps them in sight (position: sticky) on shorter windows
  var pin = document.createElement('div');
  pin.className = 'sr-pin';
  pin.appendChild(ch);
  pin.appendChild(fl);
  function prompt() {
    var p = picked(), s = !!p['Size'], f = !!p['Detail Finish'];
    ch.hidden = s && f;
    chText.textContent = !s && !f ? 'Choose a size and finish' : !s ? 'Now choose a size' : 'Now choose a finish';
    chSteps[0].textContent = s ? '✓' : '1'; chSteps[0].classList.toggle('is-done', s);
    chSteps[1].textContent = f ? '✓' : '2'; chSteps[1].classList.toggle('is-done', f);
  }

  // The controls only appear once both a size and a finish are chosen; until then the page is as before
  function ready() { var p = picked(); return !!(p['Size'] && p['Detail Finish']); }
  // The intro plays once per visit, when the pill is fully on screen (on a 900px-tall laptop the photo's bottom edge starts
  // just below the fold; a small scroll brings it up and the photo then sticks)
  var played = false, io = null;
  function runIntro() {
    played = true;
    try { sessionStorage.setItem('sr-door-intro', '1'); } catch (e) {}
    fl.classList.remove('is-intro'); void fl.offsetWidth; fl.classList.add('is-intro');
    setTimeout(function () { fl.classList.remove('is-intro'); }, 2400);
  }
  function intro() {
    if (played || io || !desk()) return;
    try { if (sessionStorage.getItem('sr-door-intro')) { played = true; return; } } catch (e) {}
    if (!('IntersectionObserver' in window)) { runIntro(); return; }
    io = new IntersectionObserver(function (es) {
      if (fl.hidden || !es.some(function (en) { return en.isIntersecting && en.intersectionRatio > 0.98; })) return;
      io.disconnect(); io = null; runIntro();
    }, { threshold: [0.99] });
    io.observe(pill);
  }
  function showBtns() {
    var on = ready();
    if (mbtn) { mbtn.style.display = on ? '' : 'none'; mnav.classList.toggle('sr-has-door', on); }
    fl.hidden = !on;
    prompt();
    if (on) intro();
    else { pinned = false; showCard(false); if (isOpen) setOpen(false); }
  }

  // ---- the colour panel
  var pop = document.createElement('div');
  pop.className = 'sr-door';
  pop.id = 'sr-door-pop';
  pop.hidden = true;
  pop.setAttribute('role', 'group');
  pop.setAttribute('aria-label', 'Door Visualiser');
  pop.innerHTML = '<div class="sr-door-top"><div class="sr-door-tabs"><button type="button" data-door-tab="laminate">Laminate</button>' +
    '<button type="button" data-door-tab="timber">Timber</button></div><button type="button" class="sr-door-done" data-door-close>Done</button></div>' +
    '<div class="sr-door-chips" data-door-chips></div><p class="sr-door-cap" data-door-cap aria-live="polite"></p>';
  var chipsBox = pop.querySelector('[data-door-chips]'), cap = pop.querySelector('[data-door-cap]');
  cap.textContent = 'Pick a door to see this handle on it.';

  // Phones: under the two bars, in the page (the arrow points at the bar). Desktop: popping up from the pill.
  function place() {
    if (desk()) {
      if (pop.parentNode !== fl) fl.insertBefore(pop, pill);
      pop.classList.add('sr-door--float'); pop.classList.remove('sr-door--inline');
      return;
    }
    if (pop.previousElementSibling !== mnav) mnav.insertAdjacentElement('afterend', pop);
    pop.classList.add('sr-door--inline'); pop.classList.remove('sr-door--float');
    if (isOpen) {
      var pr = pop.getBoundingClientRect(), br = mbtn.getBoundingClientRect();
      pop.style.setProperty('--sr-arrow', Math.round(br.left + br.width / 2 - pr.left) + 'px');
    }
  }

  function chipsHtml() {
    var html = '';
    Object.keys(OPTIONS).forEach(function (id) {
      var o = OPTIONS[id];
      if (o.kind !== tab) return;
      var t = texture(o, 120), bg = (t ? 'background-image:url(' + t + ');' : '') + 'background-color:' + o.hex;
      html += '<button type="button" class="sr-door-chip" data-door-pick="' + o.id + '" aria-label="' + E.chipLabel(o) + '" aria-pressed="' + (!!door && door.id === o.id) + '" title="' + E.chipLabel(o) + '" style="' + bg + '"></button>';
    });
    return html;
  }
  function renderChips() {
    chipsBox.innerHTML = chipsHtml();
    pop.querySelectorAll('[data-door-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-door-tab') === tab)); });
  }
  function renderBtns() {
    var aria = door ? 'Door Visualiser, showing ' + E.article(door.name) + ' ' + doorWords(door) + ' door' : 'Door Visualiser';
    if (mbtn) {
      mbtn.querySelector('.sr-door-label').textContent = door ? 'Door: ' + door.name : 'Door Visualiser';
      mbtn.classList.toggle('has-door', !!door);
      var dot = mbtn.querySelector('.sr-door-dot'), t = door ? texture(door, 64) : '';
      dot.style.backgroundImage = t ? 'url(' + t + ')' : '';
      dot.style.backgroundColor = door ? door.hex : '';
      mbtn.setAttribute('aria-label', aria);
    }
    pill.querySelector('.sr-door-pill-label').textContent = door ? 'Door: ' + door.name : 'Try it on your door';
    pill.setAttribute('aria-label', door ? aria : 'Door Visualiser: try this handle on your door colour');
    fl.querySelector('[data-new]').hidden = seen;
  }
  function setCap(t) { cap.textContent = t; }
  function loading(on) { if (mbtn) mbtn.classList.toggle('is-loading', on); pill.classList.toggle('is-loading', on); }
  function markSeen() {
    if (seen) return;
    seen = true;
    try { localStorage.setItem('sr-door-tip', '1'); } catch (e) {}
    renderBtns();
  }

  // ---- the drawing over the big photo. The theme replaces the big photo's markup on every size or finish change,
  // so the overlay (and the pill) are put back into whichever picture is there now.
  var over = document.createElement('img');
  over.className = 'sr-door-over';
  over.alt = '';
  over.setAttribute('aria-hidden', 'true');
  over.decoding = 'async';
  function frame() { return media.querySelector('picture') || media.querySelector('.hotspot-container') || media; }
  function photo() { var f = frame(); return f.querySelector('img:not(.sr-door-over)'); }
  function attach() {
    var f = frame(), host = media.querySelector('.hotspot-container') || media;
    if (over.parentNode !== f) f.appendChild(over);
    if (pin.parentNode !== host) host.appendChild(pin);
  }
  // 1024px on phones (fast enough there); 1536px for the big desktop photo on sharp screens
  function size() { return window.innerWidth >= 768 && frame().clientWidth * (window.devicePixelRatio || 1) > 1100 ? 1536 : 1024; }

  var token = 0, currentUrl = null, shownFor = '', pendingFor = '';
  function hide() { over.classList.remove('is-on'); shownFor = ''; pendingFor = ''; }
  function refresh() {
    var my = ++token;
    renderBtns();
    window.SRDoorPick = door ? { id: door.id, name: doorWords(door) } : null;
    attach();
    if (!door) { hide(); loading(false); setCap('Pick a door to see this handle on it.'); return; }
    var img = photo(), src = img ? (img.getAttribute('src') || img.currentSrc || '') : '';
    var key = E.photoKey(src), n = size(), want = key + '|' + door.id + '|' + n;
    if ((shownFor === want && over.classList.contains('is-on')) || pendingFor === want) return;
    pendingFor = want;
    over.classList.remove('is-on');
    loading(true);
    setCap('Loading your door…');
    E.manifest().then(function (m) {
      var entry = m.images[key];
      if (!entry) { var p = picked(); throw new Error(p['Size'] && p['Detail Finish'] ? 'nolayer' : 'nochoice'); }
      return E.render(entry, door, n);
    }).then(function (url) {
      if (my !== token) { URL.revokeObjectURL(url); return; }
      var old = currentUrl, d = door;
      currentUrl = url;
      over.onload = function () { if (my === token) over.classList.add('is-on'); if (old) URL.revokeObjectURL(old); };
      over.src = url;
      shownFor = want; pendingFor = '';
      loading(false);
      renderBtns();
      setCap(E.capWords(d));
    }).catch(function (e) {
      if (my !== token) return;
      hide();
      loading(false);
      setCap(e && e.message === 'nochoice' ? 'Choose a size and finish to see the handle on your door.'
        : e && e.message === 'nolayer' ? 'The door preview isn’t available for this photo yet.'
        : 'The door preview didn’t load. Please try again.');
    });
  }

  // door_tip and door_open count once per page view; a hover-open counts only if the colours stay open 0.8s (not a mouse passing over)
  var tracked = {}, openT;
  function trackOnce(name) { if (!tracked[name]) { tracked[name] = 1; track(name); } }
  function showCard(v) {
    if (v === !card.hidden) return;
    card.hidden = !v;
    pill.setAttribute('aria-expanded', String(v || isOpen));
    if (v) trackOnce('door_tip');
  }
  // explicit: opened by a click or "Show me" (not just a hover), so the default door (Warm White) is put on if none is chosen yet
  function setOpen(v, explicit) {
    if (v && explicit && !door) {
      door = OPTIONS[E.defaultDoor] || OPTIONS[Object.keys(OPTIONS)[0]]; tab = door.kind;
      try { localStorage.setItem('sr-door', JSON.stringify(door.id)); } catch (e) {}
      refresh();
    }
    if (v === isOpen) { if (v) { renderChips(); if (explicit) trackOnce('door_open'); } return; }
    isOpen = v;
    pop.hidden = !v;
    if (mbtn) mbtn.setAttribute('aria-expanded', String(v));
    pill.setAttribute('aria-expanded', String(v || !card.hidden));
    if (v) {
      markSeen();
      place();
      renderChips();
      E.manifest().then(function () { renderChips(); renderBtns(); }).catch(function () {});
      clearTimeout(openT);
      if (explicit) trackOnce('door_open');
      else openT = setTimeout(function () { if (isOpen) trackOnce('door_open'); }, 800);
    }
  }
  function closeAll() { clearTimeout(leaveT); pinned = false; showCard(false); setOpen(false); }

  if (mbtn) mbtn.addEventListener('click', function () { setOpen(!isOpen, true); });
  pill.addEventListener('click', function () {
    clearTimeout(leaveT);
    if (!card.hidden) { showCard(false); pinned = true; setOpen(true, true); return; }   // card showing: straight to the colours
    if (isOpen && pinned) { closeAll(); return; }
    if (isOpen) { pinned = true; setOpen(true, true); return; }                          // opened by hover: keep it open
    if (!seen && !canHover) { pinned = true; showCard(true); return; }                   // touch screens: first tap shows the card
    pinned = true; setOpen(true, true);
  });
  // Hover (mouse only): the card the first time, the colours after that; closes again a moment after the mouse leaves
  fl.addEventListener('mouseenter', function () {
    if (!canHover || !desk()) return;
    clearTimeout(leaveT);
    if (isOpen || !card.hidden) return;
    if (seen) setOpen(true, false); else showCard(true);
  });
  fl.addEventListener('mouseleave', function () {
    if (!canHover || pinned) return;
    clearTimeout(leaveT);
    leaveT = setTimeout(function () { showCard(false); setOpen(false); }, 250);
  });
  card.addEventListener('click', function (e) {
    if (e.target.closest('[data-card-show]')) { markSeen(); showCard(false); pinned = true; setOpen(true, true); return; }
    if (e.target.closest('[data-card-close]')) { markSeen(); closeAll(); pill.focus({ preventScroll: true }); }
  });
  fl.addEventListener('click', function (e) { e.stopPropagation(); });   // keep clicks on the pill away from the photo underneath
  pop.addEventListener('click', function (e) {
    var t = e.target.closest('[data-door-tab],[data-door-pick],[data-door-close]');
    if (!t) return;
    if (t.hasAttribute('data-door-close')) { closeAll(); activeBtn().focus({ preventScroll: true }); return; }
    if (t.hasAttribute('data-door-tab')) { tab = t.getAttribute('data-door-tab'); renderChips(); return; }
    var id = t.getAttribute('data-door-pick');
    door = id ? OPTIONS[id] : null;
    pinned = true;
    try { localStorage.setItem('sr-door', JSON.stringify(door ? door.id : null)); } catch (err) {}
    renderChips();
    refresh();
    var again = chipsBox.querySelector('[data-door-pick="' + (id || '') + '"]'); if (again) again.focus({ preventScroll: true });
    track('door', { door: door ? door.id : 'original', door_kind: door ? door.kind : 'none' });
  });
  pop.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); closeAll(); activeBtn().focus({ preventScroll: true }); } });
  // Desktop: Escape closes the card or the colours wherever focus is (they can be opened by hover alone)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !desk() || !(isOpen || !card.hidden)) return;
    var inside = fl.contains(document.activeElement);
    closeAll();
    if (inside) pill.focus({ preventScroll: true });
  });
  // Desktop: a click anywhere else closes the card or the colours
  document.addEventListener('click', function () { if (desk() && (isOpen || !card.hidden)) closeAll(); });
  var wasDesk = desk();
  window.addEventListener('resize', function () {
    var d = desk();
    if (d !== wasDesk) { wasDesk = d; closeAll(); place(); }
    else if (isOpen) place();
  });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) showBtns(); });
  // A size or a finish on its own never reaches the listener above (the theme's re-render is blocked); the guard announces it
  document.addEventListener('sr:choice', function () { prompt(); });

  // New big photo (size or finish changed): put the overlay and the pill back and redraw on the chosen door.
  // Changes to our own overlay, pill, card and panel are ignored.
  function ours(nd) { return nd === over || nd === pin || pin.contains(nd); }
  new MutationObserver(function (muts) {
    var real = muts.some(function (m) {
      if (ours(m.target)) return false;
      if (m.type === 'childList') return [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes)).some(function (nd) { return !ours(nd); });
      return true;
    });
    if (!real) return;
    attach();
    showBtns();
    if (door) refresh(); else hide();
  }).observe(media, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

  attach();
  showBtns();
  place();
  renderBtns();
  window.SRDoorPick = door ? { id: door.id, name: doorWords(door) } : null;
  if (door) refresh();
})();
